import { formatNumber } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'bonus',
  standalone: true,
  pure: true
})
export class BonusPipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(value: unknown): string {
    if (value === null || value === undefined) { return ''; }

    const n
      = typeof value === 'string'
        ? Number(value.replace(',', '.').trim())
        : Number(value);

    if (!Number.isFinite(n)) { return ''; }

    return formatNumber(n, this.locale, '1.2-2');
  }
}
